var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { RadioGroup as MuiRadioGroup } from '@mui/material';
import Radio from '../Radio';
var RadioGroup = React.forwardRef(function (_a, ref) {
    var childrenProp = _a.children, options = _a.options, RadioGroupProps = __rest(_a, ["children", "options"]);
    var children = childrenProp;
    if (children == null && (Array.isArray(options) && options.length > 0)) {
        children = options.map(function (opt) {
            return React.createElement(Radio, __assign({ key: opt.value }, opt));
        });
    }
    return (React.createElement(MuiRadioGroup, __assign({}, RadioGroupProps, { ref: ref }), children));
});
RadioGroup.defaultProps = {
    row: true,
};
export default RadioGroup;
